import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforweddingpune() {



const cardData =
  {
    keyword: 'Bus Hire for Wedding Pune',
    heading: 'Sanavi Travels: Bus Hire for Wedding Pune',
    headingDescription: 'Sanavi Travels provides reliable, elegant, and well-organized Bus Hire for Wedding Pune, helping families manage guest transportation smoothly during marriage ceremonies and related functions. Pune is one of Maharashtra’s most preferred wedding destinations, with a large number of banquet halls, wedding lawns, resorts, temples, and convention centers spread across the city and nearby outskirts. Managing transportation for hundreds of guests during weddings, receptions, engagements, and pre-wedding rituals requires professional planning and dependable vehicles. Sanavi Travels specializes in wedding bus rental services in Pune by offering a wide range of AC buses, Non-AC buses, luxury coaches, mini buses, and high-capacity buses that ensure comfort, punctuality, and coordination. Each bus is maintained with clean interiors, comfortable seating, adequate legroom, and sufficient luggage space for wedding guests traveling in traditional attire. Our experienced drivers are familiar with Pune city routes, traffic patterns, wedding venues, and outstation highways, ensuring timely pickups, disciplined driving, and smooth guest movement between homes, hotels, temples, and venues. With transparent pricing, flexible booking options, and 24/7 customer support, Sanavi Travels makes wedding bus hire in Pune stress-free, affordable, and perfectly managed for families and event organizers.',

    top: 'Popular Wedding Venues and Locations in Pune Served by Sanavi Travels',


"topPlaces": [
  {
    "title": "Wedding Banquet Halls in Pune",
    "description": "Pune has a wide range of banquet halls located across areas such as Shivajinagar, Kothrud, Hadapsar, Baner, Wakad, and Viman Nagar. These halls host weddings, receptions, engagements, and sangeet ceremonies. Bus hire services help families transport guests conveniently from homes and hotels to banquet halls without parking or traffic worries."
  },
  {
    "title": "Wedding Lawns and Open Venues",
    "description": "Wedding lawns and open venues around Pune are popular for large-scale celebrations and destination-style weddings. Bus rentals play a crucial role in managing guest movement to these venues, especially those located on city outskirts or highways."
  },
  {
    "title": "Resort and Destination Wedding Venues",
    "description": "Many couples choose resorts around Pune for destination weddings and multi-day celebrations. Hiring buses ensures smooth guest transfers between Pune city, resorts, hotels, and nearby tourist locations."
  },
  {
    "title": "Religious and Traditional Wedding Temples",
    "description": "Pune and surrounding regions have several temples where traditional wedding rituals are performed. Bus rentals make it easy to transport relatives, elders, and guests safely and comfortably to these spiritual venues."
  },
  {
    "title": "Hotels and Guest Accommodations",
    "description": "Wedding guests often stay at hotels across Pune. Bus hire services help coordinate timely pickups and drops between hotels and wedding venues, ensuring guests reach events together and on time."
  },
  {
    "title": "Pre-Wedding Function Locations",
    "description": "Functions such as haldi, mehendi, sangeet, and engagement ceremonies are often held at multiple locations. Bus rentals provide organized transportation between different function venues."
  },
  {
    "title": "Outstation Wedding Routes",
    "description": "Some weddings involve travel to nearby towns, temples, or hometowns. Outstation bus rental services ensure comfortable long-distance travel for wedding parties and relatives."
  },
  {
    "title": "Community Halls and Social Centers",
    "description": "Community halls across Pune host traditional and cultural weddings. Hiring buses helps families manage large guest lists efficiently."
  },
  {
    "title": "Marriage Registration and Legal Offices",
    "description": "Bus hire services are useful for transporting family members and guests to marriage registration offices and related appointments."
  },
  {
    "title": "Airport and Railway Station Transfers",
    "description": "Outstation guests arriving by train or flight are often transported via buses from airports and railway stations to hotels and wedding venues, ensuring coordinated arrivals."
  }
]
,



"services": [
{
"name": "Bus Hire for Wedding Pune",
"description": "Bus Hire for Wedding Pune offers complete transportation solutions for marriage ceremonies, receptions, engagements, and pre-wedding events. With multiple guests arriving from different locations, hiring a professionally managed bus ensures punctuality, safety, and smooth coordination. Sanavi Travels provides clean, spacious, and comfortable buses that allow wedding guests to travel together, reducing confusion, delays, and parking issues at venues. Experienced drivers ensure disciplined driving, timely pickups, and polite interaction with guests, making the overall wedding experience pleasant and stress-free."
},
{
"name": "Wedding Bus Rental Pune",
"description": "Wedding Bus Rental Pune is designed to support families with large guest lists by providing reliable buses for full-day or multi-day wedding events. This service helps manage guest transportation across venues, hotels, temples, and function halls without logistical challenges."
},
{
"name": "AC Wedding Bus Hire Pune",
"description": "AC Wedding Bus Hire Pune ensures a cool and comfortable environment for guests, especially during summer weddings or long travel routes. Air-conditioned buses are ideal for elders, children, and guests dressed in heavy traditional attire."
},
{
"name": "Non AC Wedding Bus on Rent Pune",
"description": "Non AC Wedding Bus on Rent Pune offers an economical option for short-distance travel and budget-conscious wedding planning while maintaining safety and reliability."
},
{
"name": "Luxury Wedding Bus Rental Pune",
"description": "Luxury Wedding Bus Rental Pune provides premium interiors, enhanced comfort, and a refined travel experience for close family members, VIP guests, and special invitees."
},
{
"name": "Mini Bus Hire for Wedding Pune",
"description": "Mini Bus Hire for Wedding Pune is perfect for smaller groups, close relatives, and shuttle services between nearby venues, offering flexibility and easy movement in city traffic."
},
{
"name": "32 Seater Wedding Bus Hire Pune",
"description": "32 Seater Wedding Bus Hire Pune is ideal for medium-sized guest groups, offering balanced seating capacity and comfort for city and outstation wedding travel."
},
{
"name": "35 Seater Wedding Bus on Rent Pune",
"description": "35 Seater Wedding Bus on Rent Pune supports large guest transportation needs during weddings, receptions, and community functions."
},
{
"name": "Bus Rental for Wedding in Pune",
"description": "Bus Rental for Wedding in Pune helps families coordinate guest movement smoothly between homes, hotels, temples, and venues, reducing stress and delays."
},
{
"name": "Bus Hire Pune for Marriage Events",
"description": "Bus Hire Pune for Marriage Events provides dependable transport solutions for all wedding-related occasions, ensuring guests arrive together and on time."
},
{
"name": "Bus on Rent for Wedding Functions Pune",
"description": "Bus on Rent for Wedding Functions Pune is suitable for haldi, mehendi, sangeet, and engagement ceremonies held at multiple locations."
},
{
"name": "Bus Hire for Wedding Guests Pune",
"description": "Bus Hire for Wedding Guests Pune ensures comfortable and safe travel for relatives, friends, elders, and children attending wedding celebrations."
},
{
"name": "Affordable Wedding Bus Rental Pune",
"description": "Affordable Wedding Bus Rental Pune offers cost-effective solutions without compromising on cleanliness, punctuality, or service quality."
},
{
"name": "Best Wedding Bus Service Pune",
"description": "Best Wedding Bus Service Pune is trusted for reliable operations, professional drivers, transparent pricing, and smooth coordination during weddings."
},
{
"name": "Wedding Bus Hire with Driver Pune",
"description": "Wedding Bus Hire with Driver Pune provides chauffeur-driven buses where experienced drivers handle routes, traffic, and schedules professionally."
}
],
"tableData": [
["Bus Hire for Wedding Pune", "Wedding Bus Rental Pune"],
["AC Wedding Bus Pune", "Non AC Wedding Bus Pune"],
["Luxury Wedding Bus Pune", "Mini Bus Wedding Pune"],
["32 Seater Wedding Bus Pune", "35 Seater Wedding Bus Pune"],
["Wedding Guest Bus Pune", "Marriage Event Bus Pune"],
["Wedding Function Bus Pune", "Outstation Wedding Bus Pune"],
["Wedding Bus with Driver Pune", "Affordable Wedding Bus Pune"],
["Best Wedding Bus Service Pune", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Wedding Bus Hire Pune with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels specializes in wedding transportation with reliable and well-coordinated bus services."
  },
  {
    "WhyChooseheading": "Experienced Wedding Event Drivers",
    "WhyChoosedescription": "Drivers are trained to manage wedding schedules, guest coordination, and venue routes."
  },
  {
    "WhyChooseheading": "Clean and Comfortable Buses",
    "WhyChoosedescription": "Buses are cleaned and prepared specially for wedding guests."
  },
  {
    "WhyChooseheading": "Transparent Wedding Pricing",
    "WhyChoosedescription": "Clear and upfront pricing with no hidden charges."
  },
  {
    "WhyChooseheading": "24/7 Coordination Support",
    "WhyChoosedescription": "Round-the-clock support for wedding day coordination and planning."
  },
  {
    "WhyChooseheading": "Flexible Booking Options",
    "WhyChoosedescription": "Hourly, full-day, and multi-day wedding packages available."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are sanitized before every wedding trip."
  },
  {
    "WhyChooseheading": "Punctual and Reliable Service",
    "WhyChoosedescription": "On-time guest pickups and smooth transportation management."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus hire for weddings in Pune?',
    answer: 'Yes, Sanavi Travels offers complete wedding bus rental services across Pune.'
  },
  {
    question: 'Are AC and Non AC wedding buses available?',
    answer: 'Yes, both AC and Non AC wedding buses are available based on your requirement.'
  },
  {
    question: 'Can buses be hired for multiple wedding functions?',
    answer: 'Yes, buses can be booked for single-day or multi-day wedding events.'
  },
  {
    question: 'Do you provide drivers with wedding buses?',
    answer: 'Yes, all wedding buses come with experienced professional drivers.'
  },
  {
    question: 'Is wedding bus pricing transparent?',
    answer: 'Yes, we follow clear pricing with no hidden charges.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Suresh Pawar',
    feedback: 'Sanavi Travels managed wedding guest transportation perfectly. Very smooth service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Neha Kulkarni',
    feedback: 'Excellent wedding bus service in Pune. Guests were very comfortable.',
    rating: 5
  }
];























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];






const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Wedding Pune - Sanavi Travels",
  "description": "Sanavi Travels offers bus hire for wedding in Pune for marriage events, wedding guests, and functions. We provide AC and Non-AC buses, luxury buses, mini buses, 32 seater and 35 seater buses with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};









  return (
    <div>
<Helmet>
  <title>
    Call : +91 7387507373 | Bus Hire for Wedding Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book bus hire for wedding in Pune with Sanavi Travels. AC & Non-AC buses, luxury and mini bus rental for marriage events, wedding guests, and functions with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/242.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Bushireforweddingpune;